import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "@lawline/ui/components/table";
import { useTranslations } from "use-intl";

// Plan table shown on the billing page. Mirrors the server TIERS in apps/api
// core/limits/tier.ts. Keep both in sync. The server is the enforcement point.
// `labelKey` and `priceKey` are i18n keys under the "billing.priceTable"
// namespace. useTranslations resolves them at render.
const PLANS = [
	{
		labelKey: "standard",
		requestsPerMinute: 60,
		monthlyLawlineQuota: 100_000_000,
		priceKey: "payPerUse",
	},
	{
		labelKey: "enterprise",
		requestsPerMinute: 600,
		monthlyLawlineQuota: 10_000_000_000,
		priceKey: "payPerUse",
	},
] as const;

const compact = new Intl.NumberFormat("en", { notation: "compact" });

export function BillingPriceTable() {
	const t = useTranslations("billing.priceTable");
	return (
		<div className="overflow-hidden rounded-md border">
			<Table>
				<TableHeader>
					<TableRow>
						<TableHead>{t("plan")}</TableHead>
						<TableHead className="text-right">{t("requestsPerMinute")}</TableHead>
						<TableHead className="text-right">{t("lawlineTokensPerMonth")}</TableHead>
						<TableHead className="text-right">{t("price")}</TableHead>
					</TableRow>
				</TableHeader>
				<TableBody>
					{PLANS.map((p) => (
						<TableRow key={p.labelKey}>
							<TableCell className="font-medium">{t(p.labelKey)}</TableCell>
							<TableCell className="text-right font-mono">{p.requestsPerMinute}</TableCell>
							<TableCell className="text-right font-mono">
								{compact.format(p.monthlyLawlineQuota)}
							</TableCell>
							<TableCell className="text-right font-mono">{t(p.priceKey)}</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</div>
	);
}
